import {
    ILLUSTRATION_TAG_ID,
    ANIMATION_TAG_ID,
    ANIMATION_FOR_HSEPERM_TAG_ID,
    BOOK_TAG_ID,
    INFOGRAPHICS_TAG_ID,

    BRAND_TAG_ID,
    DESIGN_EDUCATION_TAG_ID,
    INTERIOR_TAG_ID,
    LANDSCAPING_TER_ID,
    PUBLIC_PLACE_ID,
    TERRITORIAL_BRANDING_ID,
    URBAN_ENVIRONMENT_ID,
    DESIGN_TAG_ID,

    ADVERTISING_TAG_ID,
    ART_DIRECTION_TAG_ID,
    WEB_PUBLISH_TAG_ID,
    BOOK_DESIGN_TAD_ID,
    BASIC_DESIGN_TA_ID,
    COMMUNICATION_TAG_ID,
    CREATIVE_PROGRAMMING_TAG_ID,
    DIGITAL_PRODUCT_TAG_ID,
    INTERACTIVE_DESIGN_TAG_ID,
    MEDIA_DESIGN_TAG_ID,
    MODERN_DESIGN_TAG_ID,
    OBJECT_DESIGN_TAG_ID,
    PACKAGING_TAG_ID,
    TYPE_TAG_ID,


    COLAB_ID,
    FASHION_COLAB_ID,
    BOOK_DESIGN_ID,
    CHILD_BOOK_ID,
    VIMMELBUH_ID,
    CALENDAR_DESIGN_ID,
    CURATOR_ID,
    VIRTUAL_ID,
    PICTURE_BOOK_ID,
    PERFORMANS_ID,
    PUBLIC_ART_ID,
    DESIGN_HISTORY_ID,
    ART_HISTORY_ID,
    ILLUSTRATION_IDENTIC_ID,
    DESIGN_HSEPERM_TAG_ID,
    FOOD_PACKAGINGLAB_TAG,
    BEVERAGE_PACKAGINGLAB_TAG,
    BODY_PACKAGINGLAB_TAG,
    ART_TAG_ID,
    FASHION_TAG_ID,
    GAME_DESIGN_TAG_ID,
    BASIC_DESIGN_COURSE_TAG_ID,
    EVENTS_TAD_ID,
    SPACE_TAG_ID,
    ARTIST_TAG_ID,
    GALLERYS_TAG_ID,
    RUSSIA_TAG_ID,
    STARTSUP_TAG_ID,
    EU_TAG_ID,
    FOOD_TAG_ID,
    CULTURE_TAG_ID,

    RESEARCH_TAG_ID,
    THEMES_TAG_ID,
    ALL_RESEARCH_TAG_ID,

    SOUND_TAG_ID,
    SOUND_ART_TAG_ID,


    PEOPLE_TAG_ID,
    ARCH_TAG_ID,
    LIT_TAG_ID,
    MUSIC_TAG_ID,
    THEATRE_TAG_ID,
    EXPOSITION_TAG_ID,
    FINANCE_TAG_ID,
    NATURE_TAG_ID,
    ECOLOGY_TAG_ID,
    FLORA_AND_FAUNA_TAG_ID,
    SPORT_TAG_ID,
    HOLIDAYS_TAG_ID,
    HSELAB_DESIGN_TAG_ID,
    CITIES_TAG_ID,
    MANAGEMENT_TAG_ID,
    CREATIVE_FUTURES_TAG_ID,
    FASHION_MANT_TAG_ID,
    DESIGN_FUTURES_TAG_ID,
    GAME_FUTURES_TAG_ID,

    D_PERSON_TAG_ID,
    D_MODEL_TAG_ID,
    VIDEO_GAME_TAG_ID,
    GAME_GRAPHIC_TAG_ID,
    ANIMATIC_TAG_ID,
    HISTORY_INVESTIGATE_TAG_ID,
    TOUR_TAG_ID,
    TERBRANDING_TAG,
    FANTASY_TAG_ID,
    COMICS_TAG_ID,
    ILLUSTRATED_BOOK_TAG_ID,
    ADCODINGHUB_TAG,
    AILAB_TAG,
    HSEFONTS_TAG,
    HSEPOSTERLAB_TAG,
    HSESCREENS_TAG,


    HSECOLLECTION_PORCELAIN_TAG,
    HSECOLLECTION_TEXTILE_TAG,
    HSECOLLECTION_SILCSCREEN_TAG,
    HSECOLLECTION_STORE_TAG,
    HSECOLLECTION_PRINT_TAG,
    HSECOLLECTION_CALENDARS_TAG,
    HSEPHOTOLAB_TAG,
    EDUDESIGN_TAG,
    SOUND_ART_TAG,
    PRODUCTION_TAG,
    SOUND_DESIGN_TAG,
    STUDIES_TAG,
    SOUNDLAB_TAG,
    POSTER_TAG_ID,
    AD_POSTER_TAG,
    SOCIAL_POSTER_TAG,
    THEATER_POSTER_TAG,
    MUSEUM_TAG_ID,
    MUSEUM_BRANDING_TAG,
    MUSEUM_DESIGN_TAG,
    EXPLAINERS_TAG_ID,
    TVDESIGN_TAG_ID,
    MUSIC_CLIPS_TAG_ID,
    DDD_POST_PROD_TAG_ID,
    SOUND_ALL_TAG, AI_TAG_ID,
    EDUCATION_COURSE

} from '../../../constants/misc';

export enum ContextCodes {
  hseDesignMain = 'hsedesign_main',
  booksMain = 'main_books',
  hseLab = 'hselab',
  hseAlumni = 'hsealumni',
  dafes = 'dafes',
  hseIllustration = 'hse-illustration',
  hseColab = 'hsecolab',
  hseGallery = 'hsegallery',
  hseVisualResearch = 'hsevisualresearch',
  hsestartup = 'hsestartup',
  hseManagement = 'hsemanagement',
  hseBooks = 'hsebooks',
  hseAnimation = 'hseanimation',
  hseStart = 'hsestart',
  hseCGLAB = 'hsecglab',
  ageytomesh = 'ageytomesh',
  designGeo = 'design_geo',
  artGeo = 'art_geo',
  artDesign = 'art_deziiign',
  onlinesArt = 'onlinesart',
  eventsGeo = 'events_geo',
  creativeGeo = 'creative_geo',
  academyGeo = 'academy_geo',
  placesGeo = 'places_geo',
  mainGeo = 'main_geo',
  deziiignMain = 'design_main',
  research = 'research',
  competitions = 'competitions',
  sound = 'sound',
  sound_deziiign = 'sound_deziiign',
  profile = 'profile',
  people = 'people',
  fashionDeziiign = 'fashiondeziiign',
  gameDeziiign = 'gamedeziiign',
  proDeziiign = 'prodeziiign',
  hsePro = 'hsepro',
  hsePlaybooks = 'hseplaybooks',
  courses = 'courses',
  hseLMS = 'lmshse',
  lmsDeziiign = 'lms',
  shop = 'shop',
  exams = 'exams',
  labDeziiign = 'lab',
  russianGallllery = 'russiangallllery',
  galllleryMain = 'gallllery_main',
  hseRanepa = 'hse_ranepa',
  creativeCity = 'creativecity',
  aki = 'aki',
  galllleryArt = 'galllleryart'
}

enum IllustrationViewTab {
    illustration = 'illustration',
    comics = 'comics',
    book_illustration = 'book_illustration',
    infographics = 'infographics',
    animation = 'animation',
    // book = 'book',
}

enum HSEDESIGN_VIEW_TABS {
    design = 'design',
    art = 'art',
    fashion = 'fashion',
    all = 'all',
  }

enum LAB_VIEW_TABS {
    design = 'design',
    interior = 'interior',
    regions = 'regions',
    all = 'all',
}

enum BOOK_VIEW_TABS {
    design_book = 'design_book',
    child_book = 'child_book',
    vimmel = "vimmel",
    calendar = 'calendar',
}

enum COLAB_VIEW_TABS {
    colab = 'colab',
    fashion_colab = 'fashion_colab',
}

enum GALLERY_VIEW_TABS {
    curator = 'curator',
    picture_book = 'picture_book',
    performans = "performans",
    public_art = 'public_art'
}

enum VS_VIEW_TABS {
    // history_art = 'history_art',
    // history_design = 'history_design',
    // all = 'all',
    // vs_all = "vs_all",
    design = 'design',
    art = 'art',
    educational_courses = 'educational_courses',
    all = 'all'
}

enum ALUMNI_VIEW_TABS {
  edu_design = 'edu_design',
  edu_art = 'edu_art',
  edu_fashion = 'edu_fashion',
//   edu_events = 'edu_events',
  edu_education = 'edu_education',
  edu_startups = 'edu_startups'
}

enum HSE_VIEW_TABS {
    design = 'design',
    art = 'art',
    fashion = 'fashion',
    events = 'events',
    startups = 'startups'
}

/*ТЕГИ ОРГАНИЗ*/

enum HSEPERM_VIEW_TABS {
    design = 'design',
    animation_illustration = 'animation_illustration',
    gamedesign = 'gamedesign',
    all = 'all',
}

enum DPO_VIEW_TABS {
    all = 'all',
}

enum PACKAGINGLAB_VIEW_TABS {
    food = 'food',
    beverages = 'beverages',
    body_health_beauty = 'body_health_beauty',
    all = 'all',
}

enum ADCODINGHUB_VIEW_TABS {
    empty = 'empty',
}

enum AILAB_VIEW_TABS {
    empty = 'empty'
}

enum BRANDBUREAU_VIEW_TABS {
    all = 'all'
}

enum HSEPRINTINGHOUSE_VIEW_TABS {
    all = 'all'
}

enum HSEFONTS_VIEW_TABS {
    all = 'all'
}
enum HSEMULTIMEDIA_VIEW_TABS {
    expleiners = 'expleiners',
    tvDesign = 'tvDesign',
    musicClips = 'musicClips',
    DDDpostProduction = 'DDDpostProduction',
    all = 'all'
}

enum ARTSANDCRAFTS_VIEW_TABS {
    all = 'all'
}

enum TERBRANDING_VIEW_TABS {
    empty = 'empty'
}

enum HSEPOSTERLAB_VIEW_TABS {
    // all = 'all',
    poster = 'poster',
    adPoster = 'adPoster',
    socialPoster= 'socialPoster',
    theatrePoster = 'theatrePoster',
}

enum HSESCREENS_VIEW_TABS {
    all = 'all'
}

enum HSEMUSEUMSLAB_VIEW_TABS {
    // all = 'all',
    museumBranding = 'museumBranding',
    museumDesign = "museumDesign",
}

enum HSECOLLECTIONS_VIEW_TABS {
    porcelain = 'porcelain',
    textile = 'textile',
    silkscreen = 'silkscreen',
    hseArtAndDesignStore = 'hseArtAndDesignStore',
    hsePrintCollection = 'hsePrintCollection',
    calendars = 'calendars'
}

enum PRINT_VIEW_TABS {
    all = 'all'
}

enum HSEPHOTOLAB_VIEW_TABS {
    all = 'all'
}

enum EDUDESIGN_VIEW_TABS {
    empty = 'empty'
}

export enum COMPETITION_VIEW_TABS {
    winners = 'winners',
    competitions = 'competitions',
    fair = 'fair',
    visual_research = 'visual_research',
}

export enum COMPETITION_ADMIN_TABS {
    regular = 'regular',
    automatic = 'automatic',
    brief='brief',
    ratings='ratings'
}

export enum HSECREATIVE_VIEW_TABS {
    basic_design = 'basic_design'
}

export enum AGEYTOMESH_VIEW_TABS {
    books = 'books',
    calendars = 'calendars',
    e_books = 'null'
}

export enum DESIGN_BOOKS_VIEW_TABS {
    books = 'books'
}

export enum DESIGN_GEO_VIEW_TABS {
    // design = 'design',
    // fashion = 'fashion',
    // advertising = 'advertising',
    all = 'all',
}

export enum ART_GEO_VIEW_TABS {
    artists = 'artists',
    galleries = 'galleries',
}

export enum ONLINES_ART_VIEW_TABS {
    artists = 'artists',
    galleries = 'galleries',
    ai = 'ai',
}

export enum EVENTS_GEO_VIEW_TABS {
    real_project = 'real_project',
    fantasy_project = 'fantasy_project',
}

export enum MEDIA_GEO_VIEW_TABS {
    history = 'history',
    civil = 'civil',
    people = 'people',
    all = ''
}

export enum CREATIVE_GEO_VIEW_TABS {
    people = 'people',
    culture = 'culture',
    history = 'history',
    brands = 'brands',
    tour = 'tour',
    sport = 'sport',
    cook = 'cook',
    holidays = 'holidays',
    city = 'city'
}

export enum PLACES_GEO_VIEW_TABS {
    ru_projects = 'ru_projects',
    eu_projects = 'eu_projects',
    world_projects = 'world_projects'
}

export enum MAIN_GEO_VIEW_TABS {
    civil = 'civil',
    events = 'events',
    food = 'food',
    stories = 'stories',
    all = 'all',
}

export enum DESIGN_MAIN_VIEW_TABS {
    design = 'design',
    product = 'product',
    environment = 'environment',
    illustration = 'illustration',
    all = 'all'
}

export enum RESEARCH_VIEW_TABS {
    design = 'design',
    art = 'art',
    educational_courses = 'educational_courses',
    all = 'all'
}

export enum SOUND_VIEW_TABS {
    designLab = 'designLab',
    production = 'production',
    artLab = 'artLab',
    studies = 'studies',
    // soundLab = 'soundLab',
    all = 'all'
}

export enum SOUND_DEZIIIGN_VIEW_TABS {
    sound = 'sound',
    labels = 'labels'
}

export enum MANAGEMENT_VIEW_TABS {
    design_futures = 'design_futures',
    fashion_futures = 'fashion_futures',
    game_futures = 'game_futures',
    management = 'management',
}

export enum CGLAB_VIEW_TABS {
    character_creation = 'character_creation',
    game_development = 'game_development',
    previses_and_cinematics = 'previses_and_cinematics',
    all = 'all'
}

export enum PEOPLE_VIEW_TABS {
  teachers = "teachers",
  students = "students",
  alumnus = "alumnus",
  opa = "opa",
  opa_by_month = "opa_by_month"
}

export enum CREATIVE_FUTURES_VIEW_TABS {
    design_futures = 'design_futures',
    fashion_futures = 'fashion_futures',
    game_futures = 'game_futures',
}

export enum COURSES_VIEW_TABS {
    courses = 'courses',
} 

const TAB_TAGS_ILLUSTR = {
    [IllustrationViewTab.illustration]: ILLUSTRATION_TAG_ID,
    [IllustrationViewTab.animation]: ANIMATION_TAG_ID,
    // [IllustrationViewTab.book]: BOOK_TAG_ID,
    [IllustrationViewTab.infographics]: INFOGRAPHICS_TAG_ID,
    [IllustrationViewTab.book_illustration]: ILLUSTRATED_BOOK_TAG_ID,
    [IllustrationViewTab.comics]: COMICS_TAG_ID,
}

const TAB_TAGS_LAB = {
    [LAB_VIEW_TABS.design]: HSELAB_DESIGN_TAG_ID,
    [LAB_VIEW_TABS.interior]: INTERIOR_TAG_ID,
    [LAB_VIEW_TABS.regions]: TERRITORIAL_BRANDING_ID,
    [LAB_VIEW_TABS.all]: '',
  }

  const TAB_TAGS_BOOK = {
    [BOOK_VIEW_TABS.design_book]: BOOK_DESIGN_ID,
    [BOOK_VIEW_TABS.child_book]: CHILD_BOOK_ID,
    [BOOK_VIEW_TABS.vimmel]: VIMMELBUH_ID,
    [BOOK_VIEW_TABS.calendar]: CALENDAR_DESIGN_ID,
  }

  const COLAB_TAGS_BOOK = {
    [COLAB_VIEW_TABS.colab]: COLAB_ID,
    [COLAB_VIEW_TABS.fashion_colab]: FASHION_COLAB_ID,
  }

  const GALLERY_TAGS_BOOK = {
    [GALLERY_VIEW_TABS.curator]: CURATOR_ID,
    [GALLERY_VIEW_TABS.picture_book]: PICTURE_BOOK_ID,
    [GALLERY_VIEW_TABS.performans]: PERFORMANS_ID,
    [GALLERY_VIEW_TABS.public_art]: PUBLIC_ART_ID
  }

  const VS_TAGS_BOOK = {
    // [VS_VIEW_TABS.history_design]: DESIGN_HISTORY_ID,
    // [VS_VIEW_TABS.history_art]: ART_HISTORY_ID,
    // [VS_VIEW_TABS.all]: '',
    // [VS_VIEW_TABS.vs_all]: 'vs_all',
    [VS_VIEW_TABS.design]: THEMES_TAG_ID,
    [VS_VIEW_TABS.art]: RESEARCH_TAG_ID,
    [VS_VIEW_TABS.educational_courses]: EDUCATION_COURSE,
    [VS_VIEW_TABS.all]: ALL_RESEARCH_TAG_ID,
  }

  const ALUMNI_TAGS = {
    [ALUMNI_VIEW_TABS.edu_design]: DESIGN_TAG_ID,
    [ALUMNI_VIEW_TABS.edu_art]: ART_TAG_ID,
    [ALUMNI_VIEW_TABS.edu_fashion]: FASHION_TAG_ID,
    [ALUMNI_VIEW_TABS.edu_education]: EVENTS_TAD_ID,
    [ALUMNI_VIEW_TABS.edu_startups]: STARTSUP_TAG_ID
}

  const HSE_TAGS = {
    [HSE_VIEW_TABS.design]: DESIGN_TAG_ID,
    [HSE_VIEW_TABS.art]: ART_TAG_ID,
    [HSE_VIEW_TABS.fashion]: FASHION_TAG_ID,
    [HSE_VIEW_TABS.events]: EVENTS_TAD_ID,
    [HSE_VIEW_TABS.startups]: STARTSUP_TAG_ID
  }

  /*___________ТЕГИ ОРГАНИЗ_________*/
  
  const CREATIVE_FUTURES_TAGS = {
    [CREATIVE_FUTURES_VIEW_TABS.design_futures]: DESIGN_FUTURES_TAG_ID,
    [CREATIVE_FUTURES_VIEW_TABS.fashion_futures]: FASHION_MANT_TAG_ID,
    [CREATIVE_FUTURES_VIEW_TABS.game_futures]: GAME_FUTURES_TAG_ID,
  }

  const HSEPERM_TAGS = {
    [HSEPERM_VIEW_TABS.design]: DESIGN_HSEPERM_TAG_ID,
    [HSEPERM_VIEW_TABS.animation_illustration]: ANIMATION_FOR_HSEPERM_TAG_ID,
    [HSEPERM_VIEW_TABS.gamedesign]: GAME_DESIGN_TAG_ID,
    [HSEPERM_VIEW_TABS.all]: '',
  }

  const DPO_TAGS = {
    [DPO_VIEW_TABS.all]: '',
  }

  const PACKAGINGLAB_TAGS = {
    [PACKAGINGLAB_VIEW_TABS.food]: FOOD_PACKAGINGLAB_TAG,
    [PACKAGINGLAB_VIEW_TABS.beverages]: BEVERAGE_PACKAGINGLAB_TAG,
    [PACKAGINGLAB_VIEW_TABS.body_health_beauty]: BODY_PACKAGINGLAB_TAG,
    [PACKAGINGLAB_VIEW_TABS.all]: "",
  }

  const ADCODINGHUB_TAGS = {
    [ADCODINGHUB_VIEW_TABS.empty]: ADCODINGHUB_TAG,
  }

  const AILAB_TAGS = {
    [AILAB_VIEW_TABS.empty]: AILAB_TAG,
  }

  const HSEFONTS_TAGS = {
    [HSEFONTS_VIEW_TABS.all]: "",
  }

  const HSEPRINTINGHOUSE_TAGS = {
    [HSEPERM_VIEW_TABS.all]: "",
  }

  const HSEMULTIMEDIA_TAGS = {
    [HSEMULTIMEDIA_VIEW_TABS.expleiners]: EXPLAINERS_TAG_ID,
    [HSEMULTIMEDIA_VIEW_TABS.tvDesign]: TVDESIGN_TAG_ID,
    [HSEMULTIMEDIA_VIEW_TABS.musicClips]: MUSIC_CLIPS_TAG_ID,
    [HSEMULTIMEDIA_VIEW_TABS.DDDpostProduction]: DDD_POST_PROD_TAG_ID,
    [HSEMULTIMEDIA_VIEW_TABS.all]: "",
  }

  const BRANDBUREAU_TAGS = {
    [BRANDBUREAU_VIEW_TABS.all]: ""
  }

  const ARTSANDCRAFTS_TAGS = {
    [ARTSANDCRAFTS_VIEW_TABS.all]: ""
  }

  const TERBRANDING_TAGS = {
    [TERBRANDING_VIEW_TABS.empty]: TERBRANDING_TAG
  }

  const HSEPOSTERLAB_TAGS = {
    // [HSEPOSTERLAB_VIEW_TABS.all]: ""
    [HSEPOSTERLAB_VIEW_TABS.poster]: POSTER_TAG_ID,
    [HSEPOSTERLAB_VIEW_TABS.adPoster]: AD_POSTER_TAG,
    [HSEPOSTERLAB_VIEW_TABS.socialPoster]: SOCIAL_POSTER_TAG,
    [HSEPOSTERLAB_VIEW_TABS.theatrePoster]: THEATER_POSTER_TAG,
  }

  const HSESCREENS_TAGS = {
    [HSESCREENS_VIEW_TABS.all]: ""
  }

  const HSEMUSEUMSLAB_TAGS = {
    // [HSEMUSEUMSLAB_VIEW_TABS.all]: ''
    [HSEMUSEUMSLAB_VIEW_TABS.museumBranding]: MUSEUM_BRANDING_TAG,
    [HSEMUSEUMSLAB_VIEW_TABS.museumDesign]: MUSEUM_DESIGN_TAG,
  }

  const HSECOLLECTIONS_TAGS = {
    [HSECOLLECTIONS_VIEW_TABS.porcelain]: HSECOLLECTION_PORCELAIN_TAG,
    [HSECOLLECTIONS_VIEW_TABS.textile]: HSECOLLECTION_TEXTILE_TAG,
    [HSECOLLECTIONS_VIEW_TABS.silkscreen]: HSECOLLECTION_SILCSCREEN_TAG,
    [HSECOLLECTIONS_VIEW_TABS.hseArtAndDesignStore]: HSECOLLECTION_STORE_TAG,
    [HSECOLLECTIONS_VIEW_TABS.hsePrintCollection]: HSECOLLECTION_PRINT_TAG,
    [HSECOLLECTIONS_VIEW_TABS.calendars]: HSECOLLECTION_CALENDARS_TAG,
    
  }

  const PRINT_TAGS = {
    [PRINT_VIEW_TABS.all]: ''
  }

  const HSEPHOTOLAB_TAGS = {
    [HSEPHOTOLAB_VIEW_TABS.all]: ""
  }

  const EDUDESIGN_TAGS = {
    [EDUDESIGN_VIEW_TABS.empty]: EDUDESIGN_TAG
  }

  /*_____________end_____________*/

  const HSECREATIVE_TAGS = {
    [HSECREATIVE_VIEW_TABS.basic_design]: BASIC_DESIGN_COURSE_TAG_ID,
  }

  const AGEYTOMESH_TAGS = {
    [AGEYTOMESH_VIEW_TABS.books]: BOOK_DESIGN_TAD_ID,
    [AGEYTOMESH_VIEW_TABS.calendars]: CALENDAR_DESIGN_ID,
    [AGEYTOMESH_VIEW_TABS.e_books]: '',
  }

  const DESIGN_GEO_TAGS = {
    // [DESIGN_GEO_VIEW_TABS.design]: DESIGN_TAG_ID,
    // [DESIGN_GEO_VIEW_TABS.fashion]: FASHION_TAG_ID,
    // [DESIGN_GEO_VIEW_TABS.advertising]: ARVERTISING_NEW_TAG_ID,
    [DESIGN_GEO_VIEW_TABS.all]: '',
  }

  const ART_GEO_TAGS = {
    [ART_GEO_VIEW_TABS.artists]: ARTIST_TAG_ID,
    [ART_GEO_VIEW_TABS.galleries]: 'null', //добавить тег
  }

  const ONLINES_ART_TAGS = {
    [ONLINES_ART_VIEW_TABS.artists]: ARTIST_TAG_ID,
    [ONLINES_ART_VIEW_TABS.galleries]: 'null', //добавить тег
    [ONLINES_ART_VIEW_TABS.ai]: AI_TAG_ID
  }

  //добавить теги
  const EVENTS_GEO_TAGS = {
    [EVENTS_GEO_VIEW_TABS.real_project]: EVENTS_TAD_ID,
    [EVENTS_GEO_VIEW_TABS.fantasy_project]: FANTASY_TAG_ID
  }

//добавить теги
// const MEDIA_GEO_TAGS = {
//     [MEDIA_GEO_VIEW_TABS.history]: 'vs_all',
//     [MEDIA_GEO_VIEW_TABS.civil]: CULTURE_TAG_ID,
//     [MEDIA_GEO_VIEW_TABS.people]: 'null',
//     [MEDIA_GEO_VIEW_TABS.all]: '',

// }
const CREATIVE_GEO_TAGS = {
    [CREATIVE_GEO_VIEW_TABS.people]: PEOPLE_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.culture]: CULTURE_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.brands]: FINANCE_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.tour]: TOUR_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.city]: CITIES_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.history]: HISTORY_INVESTIGATE_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.sport]: SPORT_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.cook]: FOOD_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.holidays]: HOLIDAYS_TAG_ID,
}

  //добавить теги
const PLACES_GEO_TAGS = {
    [PLACES_GEO_VIEW_TABS.ru_projects]: RUSSIA_TAG_ID,
    [PLACES_GEO_VIEW_TABS.eu_projects]: EU_TAG_ID,
    [PLACES_GEO_VIEW_TABS.world_projects]: '',
}

const MAIN_GEO_TAGS = {
    [MAIN_GEO_VIEW_TABS.civil]: CULTURE_TAG_ID,
    [MAIN_GEO_VIEW_TABS.events]: EVENTS_TAD_ID,
    [MAIN_GEO_VIEW_TABS.food]: FOOD_TAG_ID,
    [MAIN_GEO_VIEW_TABS.stories]: 'vs_all',
    [MAIN_GEO_VIEW_TABS.all]: 'geo_all',
}

const DESIGN_MAIN_TAGS = {
    [DESIGN_MAIN_VIEW_TABS.design]: DESIGN_TAG_ID,
    [DESIGN_MAIN_VIEW_TABS.product]: 'product',
    [DESIGN_MAIN_VIEW_TABS.environment]: 'environment',
    [DESIGN_MAIN_VIEW_TABS.illustration]: ILLUSTRATION_TAG_ID,
    [DESIGN_MAIN_VIEW_TABS.all]: '',
}

const RESEARCH_MAIN_TAGS = {
    [RESEARCH_VIEW_TABS.design]: THEMES_TAG_ID,
    [RESEARCH_VIEW_TABS.art]: RESEARCH_TAG_ID,
    [RESEARCH_VIEW_TABS.educational_courses]: EDUCATION_COURSE,
    [RESEARCH_VIEW_TABS.all]: ALL_RESEARCH_TAG_ID,
}

const SOUND_DEZIIIGN_TAGS = {
    [SOUND_DEZIIIGN_VIEW_TABS.sound]: SOUND_ART_TAG_ID,
    [SOUND_DEZIIIGN_VIEW_TABS.labels]: '',
}

const SOUND_TAGS = {
    [SOUND_VIEW_TABS.designLab]: SOUND_DESIGN_TAG,
    [SOUND_VIEW_TABS.production]: PRODUCTION_TAG,
    [SOUND_VIEW_TABS.artLab]: SOUND_ART_TAG,
    [SOUND_VIEW_TABS.studies]: STUDIES_TAG,
    // [SOUND_VIEW_TABS.soundLab]: SOUNDLAB_TAG,
    [SOUND_VIEW_TABS.all]: SOUND_ALL_TAG
}

const MANAGEMENT_TAGS = {
    [MANAGEMENT_VIEW_TABS.design_futures]: DESIGN_FUTURES_TAG_ID,
    [MANAGEMENT_VIEW_TABS.fashion_futures]: FASHION_MANT_TAG_ID,
    [MANAGEMENT_VIEW_TABS.game_futures]: GAME_FUTURES_TAG_ID,
    [MANAGEMENT_VIEW_TABS.management]: MANAGEMENT_TAG_ID,
}

const CGLAB_TAGS = {
    [CGLAB_VIEW_TABS.character_creation]: D_PERSON_TAG_ID,
    [CGLAB_VIEW_TABS.game_development]: VIDEO_GAME_TAG_ID,
    [CGLAB_VIEW_TABS.previses_and_cinematics]: ANIMATIC_TAG_ID,
    [CGLAB_VIEW_TABS.all]: ''
}

const COURSES_TAGS = {
    [COURSES_VIEW_TABS.courses]: D_PERSON_TAG_ID,
}


export const getTabs = (context: string, contextType?: string) => {

    if (contextType === 'teams' && context) {
        switch(context) {
            case 'creativefutures': 
                return [CREATIVE_FUTURES_VIEW_TABS, CREATIVE_FUTURES_TAGS, CREATIVE_FUTURES_VIEW_TABS.design_futures];
            case 'edudesign': 
                return [EDUDESIGN_VIEW_TABS, EDUDESIGN_TAGS, EDUDESIGN_VIEW_TABS.empty];
            case 'hsephotolab':
                return [HSEPHOTOLAB_VIEW_TABS, HSEPHOTOLAB_TAGS, HSEPHOTOLAB_VIEW_TABS.all];
            case 'print': 
                return [PRINT_VIEW_TABS, PRINT_TAGS, PRINT_VIEW_TABS.all];
            case 'hsecollections': 
                return [HSECOLLECTIONS_VIEW_TABS, HSECOLLECTIONS_TAGS, HSECOLLECTIONS_VIEW_TABS.porcelain];
            case 'hsemuseumslab': 
                return [HSEMUSEUMSLAB_VIEW_TABS, HSEMUSEUMSLAB_TAGS, HSEMUSEUMSLAB_VIEW_TABS.museumBranding];
            case 'hsescreens': 
                return [HSESCREENS_VIEW_TABS, HSESCREENS_TAGS, HSESCREENS_VIEW_TABS.all];
            case 'hseposterlab': 
                return [HSEPOSTERLAB_VIEW_TABS, HSEPOSTERLAB_TAGS, HSEPOSTERLAB_VIEW_TABS.poster];
            case 'terbranding': 
                return [TERBRANDING_VIEW_TABS, TERBRANDING_TAGS, TERBRANDING_VIEW_TABS.empty];
            case 'artsandcrafts':
                return [ARTSANDCRAFTS_VIEW_TABS, ARTSANDCRAFTS_TAGS, ARTSANDCRAFTS_VIEW_TABS.all];
            case 'brandbureau':
                return [BRANDBUREAU_VIEW_TABS, BRANDBUREAU_TAGS, BRANDBUREAU_VIEW_TABS.all];
            case 'hsemultimedia': 
                return [HSEMULTIMEDIA_VIEW_TABS, HSEMULTIMEDIA_TAGS, HSEMULTIMEDIA_VIEW_TABS.all];
            case 'hseprintinghouse': 
                return [HSEPRINTINGHOUSE_VIEW_TABS, HSEPRINTINGHOUSE_TAGS, HSEPRINTINGHOUSE_VIEW_TABS.all];
            case 'hsefonts': 
                return [HSEFONTS_VIEW_TABS, HSEFONTS_TAGS, HSEFONTS_VIEW_TABS.all];
            case 'ailab': 
                return [AILAB_VIEW_TABS, AILAB_TAGS, AILAB_VIEW_TABS.empty];
            case 'adcodinghub':
                return [ADCODINGHUB_VIEW_TABS, ADCODINGHUB_TAGS, ADCODINGHUB_VIEW_TABS.empty];
            case 'packaginglab': 
                return [PACKAGINGLAB_VIEW_TABS, PACKAGINGLAB_TAGS, PACKAGINGLAB_VIEW_TABS.all];
            case 'hseperm' :
                return [HSEPERM_VIEW_TABS, HSEPERM_TAGS , HSEPERM_VIEW_TABS.all];
            case 'hsecreative':
                return [HSECREATIVE_VIEW_TABS, HSECREATIVE_TAGS, HSECREATIVE_VIEW_TABS.basic_design];
            case 'hse':
                return [HSE_VIEW_TABS, HSE_TAGS, HSE_VIEW_TABS.design];
            case 'dpo' :
                return [DPO_VIEW_TABS, DPO_TAGS , DPO_VIEW_TABS.all];
            case 'onlinesart' :
                return [ONLINES_ART_VIEW_TABS, ONLINES_ART_TAGS , ONLINES_ART_VIEW_TABS.artists];
            default:
                return [ALUMNI_VIEW_TABS, ALUMNI_TAGS , ALUMNI_VIEW_TABS.edu_design];
        }
    }
    switch (context) {
        case ContextCodes.courses: 
            return [COURSES_VIEW_TABS, COURSES_TAGS, COURSES_VIEW_TABS.courses]
        case ContextCodes.hseDesignMain:
            return [HSEDESIGN_VIEW_TABS, null, HSEDESIGN_VIEW_TABS.design]
        case ContextCodes.booksMain:
            return [DESIGN_BOOKS_VIEW_TABS, null, DESIGN_BOOKS_VIEW_TABS.books]
        case ContextCodes.hseLab:
            return [LAB_VIEW_TABS, TAB_TAGS_LAB , LAB_VIEW_TABS.design]
        case ContextCodes.hseAlumni:
        case ContextCodes.dafes:
            return [ALUMNI_VIEW_TABS, ALUMNI_TAGS , ALUMNI_VIEW_TABS.edu_design]
        case ContextCodes.hseIllustration :
            return [IllustrationViewTab, TAB_TAGS_ILLUSTR, IllustrationViewTab.illustration]
        case ContextCodes.hseColab :
            return [COLAB_VIEW_TABS, COLAB_TAGS_BOOK, COLAB_VIEW_TABS.colab]
        case ContextCodes.hseGallery :
            return [GALLERY_VIEW_TABS, GALLERY_TAGS_BOOK, GALLERY_VIEW_TABS.curator]
        case ContextCodes.hseVisualResearch :
            return [VS_VIEW_TABS, VS_TAGS_BOOK, VS_VIEW_TABS.design]
        case ContextCodes.hseManagement:
        case ContextCodes.hsestartup:
            return [MANAGEMENT_VIEW_TABS, MANAGEMENT_TAGS, MANAGEMENT_VIEW_TABS.management]
        case ContextCodes.hseBooks :
            return [BOOK_VIEW_TABS, TAB_TAGS_BOOK, BOOK_VIEW_TABS.design_book]
        case ContextCodes.hseCGLAB :
            return [CGLAB_VIEW_TABS, CGLAB_TAGS, CGLAB_VIEW_TABS.all]
        case ContextCodes.ageytomesh :
            return [AGEYTOMESH_VIEW_TABS, AGEYTOMESH_TAGS, AGEYTOMESH_VIEW_TABS.books]
        case ContextCodes.designGeo:
            return [DESIGN_GEO_VIEW_TABS, DESIGN_GEO_TAGS, DESIGN_GEO_VIEW_TABS.all]
        case ContextCodes.artGeo:
        case ContextCodes.artDesign:
          return [ONLINES_ART_VIEW_TABS, ONLINES_ART_TAGS, ONLINES_ART_VIEW_TABS.artists]
        case ContextCodes.eventsGeo:
            return [EVENTS_GEO_VIEW_TABS, EVENTS_GEO_TAGS, EVENTS_GEO_VIEW_TABS.real_project]
        case ContextCodes.creativeGeo:
        case ContextCodes.academyGeo:
            return [CREATIVE_GEO_VIEW_TABS, CREATIVE_GEO_TAGS, CREATIVE_GEO_VIEW_TABS.city]
        case ContextCodes.placesGeo:
            return [PLACES_GEO_VIEW_TABS, PLACES_GEO_TAGS, PLACES_GEO_VIEW_TABS.world_projects]
        case ContextCodes.mainGeo:
            return [MAIN_GEO_VIEW_TABS, MAIN_GEO_TAGS, MAIN_GEO_VIEW_TABS.civil]
        case ContextCodes.deziiignMain:
        case ContextCodes.proDeziiign:
            return [DESIGN_MAIN_VIEW_TABS, DESIGN_MAIN_TAGS, DESIGN_MAIN_VIEW_TABS.design, {designers: 'designers', studios: 'studios'}]
        case ContextCodes.research:
            return [RESEARCH_VIEW_TABS, RESEARCH_MAIN_TAGS, RESEARCH_VIEW_TABS.design]
        case ContextCodes.competitions:
            return [COMPETITION_VIEW_TABS, {}, COMPETITION_VIEW_TABS.competitions]
        case ContextCodes.sound:
            return [SOUND_VIEW_TABS, SOUND_TAGS, SOUND_VIEW_TABS.all]
        case ContextCodes.sound_deziiign:
            return [SOUND_DEZIIIGN_VIEW_TABS, SOUND_DEZIIIGN_TAGS, SOUND_DEZIIIGN_VIEW_TABS.sound, { artists: 'artists', labels: 'labels'}]
        case ContextCodes.people:
          return [PEOPLE_VIEW_TABS, {}, '']
        default:
            return [];
    }
}
import {
    ILLUSTRATION_TAG_ID,
    ANIMATION_TAG_ID,
    ANIMATION_FOR_HSEPERM_TAG_ID,
    BOOK_TAG_ID,
    INFOGRAPHICS_TAG_ID,

    BRAND_TAG_ID,
    DESIGN_EDUCATION_TAG_ID,
    INTERIOR_TAG_ID,
    LANDSCAPING_TER_ID,
    PUBLIC_PLACE_ID,
    TERRITORIAL_BRANDING_ID,
    URBAN_ENVIRONMENT_ID,
    DESIGN_TAG_ID,

    ADVERTISING_TAG_ID,
    ART_DIRECTION_TAG_ID,
    WEB_PUBLISH_TAG_ID,
    BOOK_DESIGN_TAD_ID,
    BASIC_DESIGN_TA_ID,
    COMMUNICATION_TAG_ID,
    CREATIVE_PROGRAMMING_TAG_ID,
    DIGITAL_PRODUCT_TAG_ID,
    INTERACTIVE_DESIGN_TAG_ID,
    MEDIA_DESIGN_TAG_ID,
    MODERN_DESIGN_TAG_ID,
    OBJECT_DESIGN_TAG_ID,
    PACKAGING_TAG_ID,
    TYPE_TAG_ID,


    COLAB_ID,
    FASHION_COLAB_ID,
    BOOK_DESIGN_ID,
    CHILD_BOOK_ID,
    VIMMELBUH_ID,
    CALENDAR_DESIGN_ID,
    CURATOR_ID,
    VIRTUAL_ID,
    PICTURE_BOOK_ID,
    PERFORMANS_ID,
    PUBLIC_ART_ID,
    DESIGN_HISTORY_ID,
    ART_HISTORY_ID,
    ILLUSTRATION_IDENTIC_ID,
    DESIGN_HSEPERM_TAG_ID,
    FOOD_PACKAGINGLAB_TAG,
    BEVERAGE_PACKAGINGLAB_TAG,
    BODY_PACKAGINGLAB_TAG,
    ART_TAG_ID,
    FASHION_TAG_ID,
    GAME_DESIGN_TAG_ID,
    BASIC_DESIGN_COURSE_TAG_ID,
    EVENTS_TAD_ID,
    SPACE_TAG_ID,
    ARTIST_TAG_ID,
    GALLERYS_TAG_ID,
    RUSSIA_TAG_ID,
    STARTSUP_TAG_ID,
    EU_TAG_ID,
    FOOD_TAG_ID,
    CULTURE_TAG_ID,

    RESEARCH_TAG_ID,
    THEMES_TAG_ID,
    ALL_RESEARCH_TAG_ID,

    SOUND_TAG_ID,
    SOUND_ART_TAG_ID,


    PEOPLE_TAG_ID,
    ARCH_TAG_ID,
    LIT_TAG_ID,
    MUSIC_TAG_ID,
    THEATRE_TAG_ID,
    EXPOSITION_TAG_ID,
    FINANCE_TAG_ID,
    NATURE_TAG_ID,
    ECOLOGY_TAG_ID,
    FLORA_AND_FAUNA_TAG_ID,
    SPORT_TAG_ID,
    HOLIDAYS_TAG_ID,
    HSELAB_DESIGN_TAG_ID,
    CITIES_TAG_ID,
    MANAGEMENT_TAG_ID,
    CREATIVE_FUTURES_TAG_ID,
    FASHION_MANT_TAG_ID,
    DESIGN_FUTURES_TAG_ID,
    GAME_FUTURES_TAG_ID,

    D_PERSON_TAG_ID,
    D_MODEL_TAG_ID,
    VIDEO_GAME_TAG_ID,
    GAME_GRAPHIC_TAG_ID,
    ANIMATIC_TAG_ID,
    HISTORY_INVESTIGATE_TAG_ID,
    TOUR_TAG_ID,
    TERBRANDING_TAG,
    FANTASY_TAG_ID,
    COMICS_TAG_ID,
    ILLUSTRATED_BOOK_TAG_ID,
    ADCODINGHUB_TAG,
    AILAB_TAG,
    HSEFONTS_TAG,
    HSEPOSTERLAB_TAG,
    HSESCREENS_TAG,


    HSECOLLECTION_PORCELAIN_TAG,
    HSECOLLECTION_TEXTILE_TAG,
    HSECOLLECTION_SILCSCREEN_TAG,
    HSECOLLECTION_STORE_TAG,
    HSECOLLECTION_PRINT_TAG,
    HSECOLLECTION_CALENDARS_TAG,
    HSEPHOTOLAB_TAG,
    EDUDESIGN_TAG,
    SOUND_ART_TAG,
    PRODUCTION_TAG,
    SOUND_DESIGN_TAG,
    STUDIES_TAG,
    SOUNDLAB_TAG,
    POSTER_TAG_ID,
    AD_POSTER_TAG,
    SOCIAL_POSTER_TAG,
    THEATER_POSTER_TAG,
    MUSEUM_TAG_ID,
    MUSEUM_BRANDING_TAG,
    MUSEUM_DESIGN_TAG,
    EXPLAINERS_TAG_ID,
    TVDESIGN_TAG_ID,
    MUSIC_CLIPS_TAG_ID,
    DDD_POST_PROD_TAG_ID,
    SOUND_ALL_TAG, AI_TAG_ID,
    EDUCATION_COURSE

} from '../../../constants/misc';

export enum ContextCodes {
  hseDesignMain = 'hsedesign_main',
  booksMain = 'main_books',
  hseLab = 'hselab',
  hseAlumni = 'hsealumni',
  dafes = 'dafes',
  hseIllustration = 'hse-illustration',
  hseColab = 'hsecolab',
  hseGallery = 'hsegallery',
  hseVisualResearch = 'hsevisualresearch',
  hsestartup = 'hsestartup',
  hseManagement = 'hsemanagement',
  hseBooks = 'hsebooks',
  hseAnimation = 'hseanimation',
  hseStart = 'hsestart',
  hseCGLAB = 'hsecglab',
  ageytomesh = 'ageytomesh',
  designGeo = 'design_geo',
  artGeo = 'art_geo',
  artDesign = 'art_deziiign',
  onlinesArt = 'onlinesart',
  eventsGeo = 'events_geo',
  creativeGeo = 'creative_geo',
  academyGeo = 'academy_geo',
  placesGeo = 'places_geo',
  mainGeo = 'main_geo',
  deziiignMain = 'design_main',
  research = 'research',
  competitions = 'competitions',
  sound = 'sound',
  sound_deziiign = 'sound_deziiign',
  profile = 'profile',
  people = 'people',
  fashionDeziiign = 'fashiondeziiign',
  gameDeziiign = 'gamedeziiign',
  proDeziiign = 'prodeziiign',
  hsePro = 'hsepro',
  hsePlaybooks = 'hseplaybooks',
  courses = 'courses',
  hseLMS = 'lmshse',
  lmsDeziiign = 'lms',
  shop = 'shop',
  exams = 'exams',
  labDeziiign = 'lab',
  russianGallllery = 'russiangallllery',
  galllleryMain = 'gallllery_main',
  hseRanepa = 'hse_ranepa',
  creativeCity = 'creativecity',
  aki = 'aki',
  galllleryArt = 'galllleryart'
}

enum IllustrationViewTab {
    illustration = 'illustration',
    comics = 'comics',
    book_illustration = 'book_illustration',
    infographics = 'infographics',
    animation = 'animation',
    // book = 'book',
}

enum HSEDESIGN_VIEW_TABS {
    design = 'design',
    art = 'art',
    fashion = 'fashion',
    all = 'all',
  }

enum LAB_VIEW_TABS {
    design = 'design',
    interior = 'interior',
    regions = 'regions',
    all = 'all',
}

enum BOOK_VIEW_TABS {
    design_book = 'design_book',
    child_book = 'child_book',
    vimmel = "vimmel",
    calendar = 'calendar',
}

enum COLAB_VIEW_TABS {
    colab = 'colab',
    fashion_colab = 'fashion_colab',
}

enum GALLERY_VIEW_TABS {
    curator = 'curator',
    picture_book = 'picture_book',
    performans = "performans",
    public_art = 'public_art'
}

enum VS_VIEW_TABS {
    // history_art = 'history_art',
    // history_design = 'history_design',
    // all = 'all',
    // vs_all = "vs_all",
    design = 'design',
    art = 'art',
    educational_courses = 'educational_courses',
    all = 'all'
}

enum ALUMNI_VIEW_TABS {
  edu_design = 'edu_design',
  edu_art = 'edu_art',
  edu_fashion = 'edu_fashion',
//   edu_events = 'edu_events',
  edu_education = 'edu_education',
  edu_startups = 'edu_startups'
}

enum HSE_VIEW_TABS {
    design = 'design',
    art = 'art',
    fashion = 'fashion',
    events = 'events',
    startups = 'startups'
}

/*ТЕГИ ОРГАНИЗ*/

enum HSEPERM_VIEW_TABS {
    design = 'design',
    animation_illustration = 'animation_illustration',
    gamedesign = 'gamedesign',
    all = 'all',
}

enum DPO_VIEW_TABS {
    all = 'all',
}

enum PACKAGINGLAB_VIEW_TABS {
    food = 'food',
    beverages = 'beverages',
    body_health_beauty = 'body_health_beauty',
    all = 'all',
}

enum ADCODINGHUB_VIEW_TABS {
    empty = 'empty',
}

enum AILAB_VIEW_TABS {
    empty = 'empty'
}

enum BRANDBUREAU_VIEW_TABS {
    all = 'all'
}

enum HSEPRINTINGHOUSE_VIEW_TABS {
    all = 'all'
}

enum HSEFONTS_VIEW_TABS {
    all = 'all'
}
enum HSEMULTIMEDIA_VIEW_TABS {
    expleiners = 'expleiners',
    tvDesign = 'tvDesign',
    musicClips = 'musicClips',
    DDDpostProduction = 'DDDpostProduction',
    all = 'all'
}

enum ARTSANDCRAFTS_VIEW_TABS {
    all = 'all'
}

enum TERBRANDING_VIEW_TABS {
    empty = 'empty'
}

enum HSEPOSTERLAB_VIEW_TABS {
    // all = 'all',
    poster = 'poster',
    adPoster = 'adPoster',
    socialPoster= 'socialPoster',
    theatrePoster = 'theatrePoster',
}

enum HSESCREENS_VIEW_TABS {
    all = 'all'
}

enum HSEMUSEUMSLAB_VIEW_TABS {
    // all = 'all',
    museumBranding = 'museumBranding',
    museumDesign = "museumDesign",
}

enum HSECOLLECTIONS_VIEW_TABS {
    porcelain = 'porcelain',
    textile = 'textile',
    silkscreen = 'silkscreen',
    hseArtAndDesignStore = 'hseArtAndDesignStore',
    hsePrintCollection = 'hsePrintCollection',
    calendars = 'calendars'
}

enum PRINT_VIEW_TABS {
    all = 'all'
}

enum HSEPHOTOLAB_VIEW_TABS {
    all = 'all'
}

enum EDUDESIGN_VIEW_TABS {
    empty = 'empty'
}

export enum COMPETITION_VIEW_TABS {
    winners = 'winners',
    competitions = 'competitions',
    fair = 'fair',
    visual_research = 'visual_research',
}

export enum COMPETITION_ADMIN_TABS {
    regular = 'regular',
    automatic = 'automatic',
    brief='brief',
    ratings='ratings'
}

export enum HSECREATIVE_VIEW_TABS {
    basic_design = 'basic_design'
}

export enum AGEYTOMESH_VIEW_TABS {
    books = 'books',
    calendars = 'calendars',
    e_books = 'null'
}

export enum DESIGN_BOOKS_VIEW_TABS {
    books = 'books'
}

export enum DESIGN_GEO_VIEW_TABS {
    // design = 'design',
    // fashion = 'fashion',
    // advertising = 'advertising',
    all = 'all',
}

export enum ART_GEO_VIEW_TABS {
    artists = 'artists',
    galleries = 'galleries',
}

export enum ONLINES_ART_VIEW_TABS {
    artists = 'artists',
    galleries = 'galleries',
    ai = 'ai',
}

export enum EVENTS_GEO_VIEW_TABS {
    real_project = 'real_project',
    fantasy_project = 'fantasy_project',
}

export enum MEDIA_GEO_VIEW_TABS {
    history = 'history',
    civil = 'civil',
    people = 'people',
    all = ''
}

export enum CREATIVE_GEO_VIEW_TABS {
    people = 'people',
    culture = 'culture',
    history = 'history',
    brands = 'brands',
    tour = 'tour',
    sport = 'sport',
    cook = 'cook',
    holidays = 'holidays',
    city = 'city'
}

export enum PLACES_GEO_VIEW_TABS {
    ru_projects = 'ru_projects',
    eu_projects = 'eu_projects',
    world_projects = 'world_projects'
}

export enum MAIN_GEO_VIEW_TABS {
    civil = 'civil',
    events = 'events',
    food = 'food',
    stories = 'stories',
    all = 'all',
}

export enum DESIGN_MAIN_VIEW_TABS {
    design = 'design',
    product = 'product',
    environment = 'environment',
    illustration = 'illustration',
    all = 'all'
}

export enum RESEARCH_VIEW_TABS {
    design = 'design',
    art = 'art',
    educational_courses = 'educational_courses',
    all = 'all'
}

export enum SOUND_VIEW_TABS {
    designLab = 'designLab',
    production = 'production',
    artLab = 'artLab',
    studies = 'studies',
    // soundLab = 'soundLab',
    all = 'all'
}

export enum SOUND_DEZIIIGN_VIEW_TABS {
    sound = 'sound',
    labels = 'labels'
}

export enum MANAGEMENT_VIEW_TABS {
    design_futures = 'design_futures',
    fashion_futures = 'fashion_futures',
    game_futures = 'game_futures',
    management = 'management',
}

export enum CGLAB_VIEW_TABS {
    character_creation = 'character_creation',
    game_development = 'game_development',
    previses_and_cinematics = 'previses_and_cinematics',
    all = 'all'
}

export enum PEOPLE_VIEW_TABS {
  teachers = "teachers",
  students = "students",
  alumnus = "alumnus",
  opa = "opa",
  opa_by_month = "opa_by_month"
}

export enum CREATIVE_FUTURES_VIEW_TABS {
    design_futures = 'design_futures',
    fashion_futures = 'fashion_futures',
    game_futures = 'game_futures',
}

export enum COURSES_VIEW_TABS {
    courses = 'courses',
} 

const TAB_TAGS_ILLUSTR = {
    [IllustrationViewTab.illustration]: ILLUSTRATION_TAG_ID,
    [IllustrationViewTab.animation]: ANIMATION_TAG_ID,
    // [IllustrationViewTab.book]: BOOK_TAG_ID,
    [IllustrationViewTab.infographics]: INFOGRAPHICS_TAG_ID,
    [IllustrationViewTab.book_illustration]: ILLUSTRATED_BOOK_TAG_ID,
    [IllustrationViewTab.comics]: COMICS_TAG_ID,
}

const TAB_TAGS_LAB = {
    [LAB_VIEW_TABS.design]: HSELAB_DESIGN_TAG_ID,
    [LAB_VIEW_TABS.interior]: INTERIOR_TAG_ID,
    [LAB_VIEW_TABS.regions]: TERRITORIAL_BRANDING_ID,
    [LAB_VIEW_TABS.all]: '',
  }

  const TAB_TAGS_BOOK = {
    [BOOK_VIEW_TABS.design_book]: BOOK_DESIGN_ID,
    [BOOK_VIEW_TABS.child_book]: CHILD_BOOK_ID,
    [BOOK_VIEW_TABS.vimmel]: VIMMELBUH_ID,
    [BOOK_VIEW_TABS.calendar]: CALENDAR_DESIGN_ID,
  }

  const COLAB_TAGS_BOOK = {
    [COLAB_VIEW_TABS.colab]: COLAB_ID,
    [COLAB_VIEW_TABS.fashion_colab]: FASHION_COLAB_ID,
  }

  const GALLERY_TAGS_BOOK = {
    [GALLERY_VIEW_TABS.curator]: CURATOR_ID,
    [GALLERY_VIEW_TABS.picture_book]: PICTURE_BOOK_ID,
    [GALLERY_VIEW_TABS.performans]: PERFORMANS_ID,
    [GALLERY_VIEW_TABS.public_art]: PUBLIC_ART_ID
  }

  const VS_TAGS_BOOK = {
    // [VS_VIEW_TABS.history_design]: DESIGN_HISTORY_ID,
    // [VS_VIEW_TABS.history_art]: ART_HISTORY_ID,
    // [VS_VIEW_TABS.all]: '',
    // [VS_VIEW_TABS.vs_all]: 'vs_all',
    [VS_VIEW_TABS.design]: THEMES_TAG_ID,
    [VS_VIEW_TABS.art]: RESEARCH_TAG_ID,
    [VS_VIEW_TABS.educational_courses]: EDUCATION_COURSE,
    [VS_VIEW_TABS.all]: ALL_RESEARCH_TAG_ID,
  }

  const ALUMNI_TAGS = {
    [ALUMNI_VIEW_TABS.edu_design]: DESIGN_TAG_ID,
    [ALUMNI_VIEW_TABS.edu_art]: ART_TAG_ID,
    [ALUMNI_VIEW_TABS.edu_fashion]: FASHION_TAG_ID,
    [ALUMNI_VIEW_TABS.edu_education]: EVENTS_TAD_ID,
    [ALUMNI_VIEW_TABS.edu_startups]: STARTSUP_TAG_ID
}

  const HSE_TAGS = {
    [HSE_VIEW_TABS.design]: DESIGN_TAG_ID,
    [HSE_VIEW_TABS.art]: ART_TAG_ID,
    [HSE_VIEW_TABS.fashion]: FASHION_TAG_ID,
    [HSE_VIEW_TABS.events]: EVENTS_TAD_ID,
    [HSE_VIEW_TABS.startups]: STARTSUP_TAG_ID
  }

  /*___________ТЕГИ ОРГАНИЗ_________*/
  
  const CREATIVE_FUTURES_TAGS = {
    [CREATIVE_FUTURES_VIEW_TABS.design_futures]: DESIGN_FUTURES_TAG_ID,
    [CREATIVE_FUTURES_VIEW_TABS.fashion_futures]: FASHION_MANT_TAG_ID,
    [CREATIVE_FUTURES_VIEW_TABS.game_futures]: GAME_FUTURES_TAG_ID,
  }

  const HSEPERM_TAGS = {
    [HSEPERM_VIEW_TABS.design]: DESIGN_HSEPERM_TAG_ID,
    [HSEPERM_VIEW_TABS.animation_illustration]: ANIMATION_FOR_HSEPERM_TAG_ID,
    [HSEPERM_VIEW_TABS.gamedesign]: GAME_DESIGN_TAG_ID,
    [HSEPERM_VIEW_TABS.all]: '',
  }

  const DPO_TAGS = {
    [DPO_VIEW_TABS.all]: '',
  }

  const PACKAGINGLAB_TAGS = {
    [PACKAGINGLAB_VIEW_TABS.food]: FOOD_PACKAGINGLAB_TAG,
    [PACKAGINGLAB_VIEW_TABS.beverages]: BEVERAGE_PACKAGINGLAB_TAG,
    [PACKAGINGLAB_VIEW_TABS.body_health_beauty]: BODY_PACKAGINGLAB_TAG,
    [PACKAGINGLAB_VIEW_TABS.all]: "",
  }

  const ADCODINGHUB_TAGS = {
    [ADCODINGHUB_VIEW_TABS.empty]: ADCODINGHUB_TAG,
  }

  const AILAB_TAGS = {
    [AILAB_VIEW_TABS.empty]: AILAB_TAG,
  }

  const HSEFONTS_TAGS = {
    [HSEFONTS_VIEW_TABS.all]: "",
  }

  const HSEPRINTINGHOUSE_TAGS = {
    [HSEPERM_VIEW_TABS.all]: "",
  }

  const HSEMULTIMEDIA_TAGS = {
    [HSEMULTIMEDIA_VIEW_TABS.expleiners]: EXPLAINERS_TAG_ID,
    [HSEMULTIMEDIA_VIEW_TABS.tvDesign]: TVDESIGN_TAG_ID,
    [HSEMULTIMEDIA_VIEW_TABS.musicClips]: MUSIC_CLIPS_TAG_ID,
    [HSEMULTIMEDIA_VIEW_TABS.DDDpostProduction]: DDD_POST_PROD_TAG_ID,
    [HSEMULTIMEDIA_VIEW_TABS.all]: "",
  }

  const BRANDBUREAU_TAGS = {
    [BRANDBUREAU_VIEW_TABS.all]: ""
  }

  const ARTSANDCRAFTS_TAGS = {
    [ARTSANDCRAFTS_VIEW_TABS.all]: ""
  }

  const TERBRANDING_TAGS = {
    [TERBRANDING_VIEW_TABS.empty]: TERBRANDING_TAG
  }

  const HSEPOSTERLAB_TAGS = {
    // [HSEPOSTERLAB_VIEW_TABS.all]: ""
    [HSEPOSTERLAB_VIEW_TABS.poster]: POSTER_TAG_ID,
    [HSEPOSTERLAB_VIEW_TABS.adPoster]: AD_POSTER_TAG,
    [HSEPOSTERLAB_VIEW_TABS.socialPoster]: SOCIAL_POSTER_TAG,
    [HSEPOSTERLAB_VIEW_TABS.theatrePoster]: THEATER_POSTER_TAG,
  }

  const HSESCREENS_TAGS = {
    [HSESCREENS_VIEW_TABS.all]: ""
  }

  const HSEMUSEUMSLAB_TAGS = {
    // [HSEMUSEUMSLAB_VIEW_TABS.all]: ''
    [HSEMUSEUMSLAB_VIEW_TABS.museumBranding]: MUSEUM_BRANDING_TAG,
    [HSEMUSEUMSLAB_VIEW_TABS.museumDesign]: MUSEUM_DESIGN_TAG,
  }

  const HSECOLLECTIONS_TAGS = {
    [HSECOLLECTIONS_VIEW_TABS.porcelain]: HSECOLLECTION_PORCELAIN_TAG,
    [HSECOLLECTIONS_VIEW_TABS.textile]: HSECOLLECTION_TEXTILE_TAG,
    [HSECOLLECTIONS_VIEW_TABS.silkscreen]: HSECOLLECTION_SILCSCREEN_TAG,
    [HSECOLLECTIONS_VIEW_TABS.hseArtAndDesignStore]: HSECOLLECTION_STORE_TAG,
    [HSECOLLECTIONS_VIEW_TABS.hsePrintCollection]: HSECOLLECTION_PRINT_TAG,
    [HSECOLLECTIONS_VIEW_TABS.calendars]: HSECOLLECTION_CALENDARS_TAG,
    
  }

  const PRINT_TAGS = {
    [PRINT_VIEW_TABS.all]: ''
  }

  const HSEPHOTOLAB_TAGS = {
    [HSEPHOTOLAB_VIEW_TABS.all]: ""
  }

  const EDUDESIGN_TAGS = {
    [EDUDESIGN_VIEW_TABS.empty]: EDUDESIGN_TAG
  }

  /*_____________end_____________*/

  const HSECREATIVE_TAGS = {
    [HSECREATIVE_VIEW_TABS.basic_design]: BASIC_DESIGN_COURSE_TAG_ID,
  }

  const AGEYTOMESH_TAGS = {
    [AGEYTOMESH_VIEW_TABS.books]: BOOK_DESIGN_TAD_ID,
    [AGEYTOMESH_VIEW_TABS.calendars]: CALENDAR_DESIGN_ID,
    [AGEYTOMESH_VIEW_TABS.e_books]: '',
  }

  const DESIGN_GEO_TAGS = {
    // [DESIGN_GEO_VIEW_TABS.design]: DESIGN_TAG_ID,
    // [DESIGN_GEO_VIEW_TABS.fashion]: FASHION_TAG_ID,
    // [DESIGN_GEO_VIEW_TABS.advertising]: ARVERTISING_NEW_TAG_ID,
    [DESIGN_GEO_VIEW_TABS.all]: '',
  }

  const ART_GEO_TAGS = {
    [ART_GEO_VIEW_TABS.artists]: ARTIST_TAG_ID,
    [ART_GEO_VIEW_TABS.galleries]: 'null', //добавить тег
  }

  const ONLINES_ART_TAGS = {
    [ONLINES_ART_VIEW_TABS.artists]: ARTIST_TAG_ID,
    [ONLINES_ART_VIEW_TABS.galleries]: 'null', //добавить тег
    [ONLINES_ART_VIEW_TABS.ai]: AI_TAG_ID
  }

  //добавить теги
  const EVENTS_GEO_TAGS = {
    [EVENTS_GEO_VIEW_TABS.real_project]: EVENTS_TAD_ID,
    [EVENTS_GEO_VIEW_TABS.fantasy_project]: FANTASY_TAG_ID
  }

//добавить теги
// const MEDIA_GEO_TAGS = {
//     [MEDIA_GEO_VIEW_TABS.history]: 'vs_all',
//     [MEDIA_GEO_VIEW_TABS.civil]: CULTURE_TAG_ID,
//     [MEDIA_GEO_VIEW_TABS.people]: 'null',
//     [MEDIA_GEO_VIEW_TABS.all]: '',

// }
const CREATIVE_GEO_TAGS = {
    [CREATIVE_GEO_VIEW_TABS.people]: PEOPLE_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.culture]: CULTURE_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.brands]: FINANCE_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.tour]: TOUR_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.city]: CITIES_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.history]: HISTORY_INVESTIGATE_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.sport]: SPORT_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.cook]: FOOD_TAG_ID,
    [CREATIVE_GEO_VIEW_TABS.holidays]: HOLIDAYS_TAG_ID,
}

  //добавить теги
const PLACES_GEO_TAGS = {
    [PLACES_GEO_VIEW_TABS.ru_projects]: RUSSIA_TAG_ID,
    [PLACES_GEO_VIEW_TABS.eu_projects]: EU_TAG_ID,
    [PLACES_GEO_VIEW_TABS.world_projects]: '',
}

const MAIN_GEO_TAGS = {
    [MAIN_GEO_VIEW_TABS.civil]: CULTURE_TAG_ID,
    [MAIN_GEO_VIEW_TABS.events]: EVENTS_TAD_ID,
    [MAIN_GEO_VIEW_TABS.food]: FOOD_TAG_ID,
    [MAIN_GEO_VIEW_TABS.stories]: 'vs_all',
    [MAIN_GEO_VIEW_TABS.all]: 'geo_all',
}

const DESIGN_MAIN_TAGS = {
    [DESIGN_MAIN_VIEW_TABS.design]: DESIGN_TAG_ID,
    [DESIGN_MAIN_VIEW_TABS.product]: 'product',
    [DESIGN_MAIN_VIEW_TABS.environment]: 'environment',
    [DESIGN_MAIN_VIEW_TABS.illustration]: ILLUSTRATION_TAG_ID,
    [DESIGN_MAIN_VIEW_TABS.all]: '',
}

const RESEARCH_MAIN_TAGS = {
    [RESEARCH_VIEW_TABS.design]: THEMES_TAG_ID,
    [RESEARCH_VIEW_TABS.art]: RESEARCH_TAG_ID,
    [RESEARCH_VIEW_TABS.educational_courses]: EDUCATION_COURSE,
    [RESEARCH_VIEW_TABS.all]: ALL_RESEARCH_TAG_ID,
}

const SOUND_DEZIIIGN_TAGS = {
    [SOUND_DEZIIIGN_VIEW_TABS.sound]: SOUND_ART_TAG_ID,
    [SOUND_DEZIIIGN_VIEW_TABS.labels]: '',
}

const SOUND_TAGS = {
    [SOUND_VIEW_TABS.designLab]: SOUND_DESIGN_TAG,
    [SOUND_VIEW_TABS.production]: PRODUCTION_TAG,
    [SOUND_VIEW_TABS.artLab]: SOUND_ART_TAG,
    [SOUND_VIEW_TABS.studies]: STUDIES_TAG,
    // [SOUND_VIEW_TABS.soundLab]: SOUNDLAB_TAG,
    [SOUND_VIEW_TABS.all]: SOUND_ALL_TAG
}

const MANAGEMENT_TAGS = {
    [MANAGEMENT_VIEW_TABS.design_futures]: DESIGN_FUTURES_TAG_ID,
    [MANAGEMENT_VIEW_TABS.fashion_futures]: FASHION_MANT_TAG_ID,
    [MANAGEMENT_VIEW_TABS.game_futures]: GAME_FUTURES_TAG_ID,
    [MANAGEMENT_VIEW_TABS.management]: MANAGEMENT_TAG_ID,
}

const CGLAB_TAGS = {
    [CGLAB_VIEW_TABS.character_creation]: D_PERSON_TAG_ID,
    [CGLAB_VIEW_TABS.game_development]: VIDEO_GAME_TAG_ID,
    [CGLAB_VIEW_TABS.previses_and_cinematics]: ANIMATIC_TAG_ID,
    [CGLAB_VIEW_TABS.all]: ''
}

const COURSES_TAGS = {
    [COURSES_VIEW_TABS.courses]: D_PERSON_TAG_ID,
}


export const getTabs = (context: string, contextType?: string) => {

    if (contextType === 'teams' && context) {
        switch(context) {
            case 'creativefutures': 
                return [CREATIVE_FUTURES_VIEW_TABS, CREATIVE_FUTURES_TAGS, CREATIVE_FUTURES_VIEW_TABS.design_futures];
            case 'edudesign': 
                return [EDUDESIGN_VIEW_TABS, EDUDESIGN_TAGS, EDUDESIGN_VIEW_TABS.empty];
            case 'hsephotolab':
                return [HSEPHOTOLAB_VIEW_TABS, HSEPHOTOLAB_TAGS, HSEPHOTOLAB_VIEW_TABS.all];
            case 'print': 
                return [PRINT_VIEW_TABS, PRINT_TAGS, PRINT_VIEW_TABS.all];
            case 'hsecollections': 
                return [HSECOLLECTIONS_VIEW_TABS, HSECOLLECTIONS_TAGS, HSECOLLECTIONS_VIEW_TABS.porcelain];
            case 'hsemuseumslab': 
                return [HSEMUSEUMSLAB_VIEW_TABS, HSEMUSEUMSLAB_TAGS, HSEMUSEUMSLAB_VIEW_TABS.museumBranding];
            case 'hsescreens': 
                return [HSESCREENS_VIEW_TABS, HSESCREENS_TAGS, HSESCREENS_VIEW_TABS.all];
            case 'hseposterlab': 
                return [HSEPOSTERLAB_VIEW_TABS, HSEPOSTERLAB_TAGS, HSEPOSTERLAB_VIEW_TABS.poster];
            case 'terbranding': 
                return [TERBRANDING_VIEW_TABS, TERBRANDING_TAGS, TERBRANDING_VIEW_TABS.empty];
            case 'artsandcrafts':
                return [ARTSANDCRAFTS_VIEW_TABS, ARTSANDCRAFTS_TAGS, ARTSANDCRAFTS_VIEW_TABS.all];
            case 'brandbureau':
                return [BRANDBUREAU_VIEW_TABS, BRANDBUREAU_TAGS, BRANDBUREAU_VIEW_TABS.all];
            case 'hsemultimedia': 
                return [HSEMULTIMEDIA_VIEW_TABS, HSEMULTIMEDIA_TAGS, HSEMULTIMEDIA_VIEW_TABS.all];
            case 'hseprintinghouse': 
                return [HSEPRINTINGHOUSE_VIEW_TABS, HSEPRINTINGHOUSE_TAGS, HSEPRINTINGHOUSE_VIEW_TABS.all];
            case 'hsefonts': 
                return [HSEFONTS_VIEW_TABS, HSEFONTS_TAGS, HSEFONTS_VIEW_TABS.all];
            case 'ailab': 
                return [AILAB_VIEW_TABS, AILAB_TAGS, AILAB_VIEW_TABS.empty];
            case 'adcodinghub':
                return [ADCODINGHUB_VIEW_TABS, ADCODINGHUB_TAGS, ADCODINGHUB_VIEW_TABS.empty];
            case 'packaginglab': 
                return [PACKAGINGLAB_VIEW_TABS, PACKAGINGLAB_TAGS, PACKAGINGLAB_VIEW_TABS.all];
            case 'hseperm' :
                return [HSEPERM_VIEW_TABS, HSEPERM_TAGS , HSEPERM_VIEW_TABS.all];
            case 'hsecreative':
                return [HSECREATIVE_VIEW_TABS, HSECREATIVE_TAGS, HSECREATIVE_VIEW_TABS.basic_design];
            case 'hse':
                return [HSE_VIEW_TABS, HSE_TAGS, HSE_VIEW_TABS.design];
            case 'dpo' :
                return [DPO_VIEW_TABS, DPO_TAGS , DPO_VIEW_TABS.all];
            case 'onlinesart' :
                return [ONLINES_ART_VIEW_TABS, ONLINES_ART_TAGS , ONLINES_ART_VIEW_TABS.artists];
            default:
                return [ALUMNI_VIEW_TABS, ALUMNI_TAGS , ALUMNI_VIEW_TABS.edu_design];
        }
    }
    switch (context) {
        case ContextCodes.courses: 
            return [COURSES_VIEW_TABS, COURSES_TAGS, COURSES_VIEW_TABS.courses]
        case ContextCodes.hseDesignMain:
            return [HSEDESIGN_VIEW_TABS, null, HSEDESIGN_VIEW_TABS.design]
        case ContextCodes.booksMain:
            return [DESIGN_BOOKS_VIEW_TABS, null, DESIGN_BOOKS_VIEW_TABS.books]
        case ContextCodes.hseLab:
            return [LAB_VIEW_TABS, TAB_TAGS_LAB , LAB_VIEW_TABS.design]
        case ContextCodes.hseAlumni:
        case ContextCodes.dafes:
            return [ALUMNI_VIEW_TABS, ALUMNI_TAGS , ALUMNI_VIEW_TABS.edu_design]
        case ContextCodes.hseIllustration :
            return [IllustrationViewTab, TAB_TAGS_ILLUSTR, IllustrationViewTab.illustration]
        case ContextCodes.hseColab :
            return [COLAB_VIEW_TABS, COLAB_TAGS_BOOK, COLAB_VIEW_TABS.colab]
        case ContextCodes.hseGallery :
            return [GALLERY_VIEW_TABS, GALLERY_TAGS_BOOK, GALLERY_VIEW_TABS.curator]
        case ContextCodes.hseVisualResearch :
            return [VS_VIEW_TABS, VS_TAGS_BOOK, VS_VIEW_TABS.design]
        case ContextCodes.hseManagement:
        case ContextCodes.hsestartup:
            return [MANAGEMENT_VIEW_TABS, MANAGEMENT_TAGS, MANAGEMENT_VIEW_TABS.management]
        case ContextCodes.hseBooks :
            return [BOOK_VIEW_TABS, TAB_TAGS_BOOK, BOOK_VIEW_TABS.design_book]
        case ContextCodes.hseCGLAB :
            return [CGLAB_VIEW_TABS, CGLAB_TAGS, CGLAB_VIEW_TABS.all]
        case ContextCodes.ageytomesh :
            return [AGEYTOMESH_VIEW_TABS, AGEYTOMESH_TAGS, AGEYTOMESH_VIEW_TABS.books]
        case ContextCodes.designGeo:
            return [DESIGN_GEO_VIEW_TABS, DESIGN_GEO_TAGS, DESIGN_GEO_VIEW_TABS.all]
        case ContextCodes.artGeo:
        case ContextCodes.artDesign:
          return [ONLINES_ART_VIEW_TABS, ONLINES_ART_TAGS, ONLINES_ART_VIEW_TABS.artists]
        case ContextCodes.eventsGeo:
            return [EVENTS_GEO_VIEW_TABS, EVENTS_GEO_TAGS, EVENTS_GEO_VIEW_TABS.real_project]
        case ContextCodes.creativeGeo:
        case ContextCodes.academyGeo:
            return [CREATIVE_GEO_VIEW_TABS, CREATIVE_GEO_TAGS, CREATIVE_GEO_VIEW_TABS.city]
        case ContextCodes.placesGeo:
            return [PLACES_GEO_VIEW_TABS, PLACES_GEO_TAGS, PLACES_GEO_VIEW_TABS.world_projects]
        case ContextCodes.mainGeo:
            return [MAIN_GEO_VIEW_TABS, MAIN_GEO_TAGS, MAIN_GEO_VIEW_TABS.civil]
        case ContextCodes.deziiignMain:
        case ContextCodes.proDeziiign:
            return [DESIGN_MAIN_VIEW_TABS, DESIGN_MAIN_TAGS, DESIGN_MAIN_VIEW_TABS.design, {designers: 'designers', studios: 'studios'}]
        case ContextCodes.research:
            return [RESEARCH_VIEW_TABS, RESEARCH_MAIN_TAGS, RESEARCH_VIEW_TABS.design]
        case ContextCodes.competitions:
            return [COMPETITION_VIEW_TABS, {}, COMPETITION_VIEW_TABS.competitions]
        case ContextCodes.sound:
            return [SOUND_VIEW_TABS, SOUND_TAGS, SOUND_VIEW_TABS.all]
        case ContextCodes.sound_deziiign:
            return [SOUND_DEZIIIGN_VIEW_TABS, SOUND_DEZIIIGN_TAGS, SOUND_DEZIIIGN_VIEW_TABS.sound, { artists: 'artists', labels: 'labels'}]
        case ContextCodes.people:
          return [PEOPLE_VIEW_TABS, {}, '']
        default:
            return [];
    }
}
